export const Loader = () => {
    return (
      <div data-testid="loader-container" className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center loader-style">
        <span data-testid="loader" className='loader'></span>
      </div>
    );
  };
  